"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
import { Flash } from "../components/flash_messages";
export default {
  trainingUserData: function(accountId) {
    return ApiService.addErrorHandler(
      $.get("/api/training_lessons/training_user_lessons", { account_id: accountId }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  completeLesson: function(accountId, trainingToken) {
    ApiService.addErrorHandler(
      $.post("/api/training_lessons/complete_lesson", { account_id: accountId }).then(() => Auth.logout()).then(() => Flash.success("Lesson completed!")).then(() => $.get("/training_users/" + trainingToken, {})).then(() => Auth.login()).then(() => window.location = "/app")
    );
  },
  watchedVideo: function(accountId) {
    ApiService.addErrorHandler(
      $.post("/api/training_lessons/watched_video", { account_id: accountId })
    );
  }
};
